import { render, staticRenderFns } from "./ValueList.vue?vue&type=template&id=0d7bf506&"
import script from "./ValueList.vue?vue&type=script&lang=js&"
export * from "./ValueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports